import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ds-lib-disconnect-button',
  templateUrl: './ds-lib-disconnect-button.component.html',
  styleUrls: ['./ds-lib-disconnect-button.component.scss'],
})
export class DsLibDisconnectButtonComponent {
  /**
   * Is the menu expanded
   */
  @Input() isExpanded: boolean;

  /**
   * The disconnect button title font size
   */
  @Input() fontSize: string;

  /**
   * Emit the logout event.
   */
  @Output() logout = new EventEmitter();

  /**
   * Emmit the logount event.
   */
  public onLogout() {
    this.logout.emit();
  }
}
